// src/admin/FormEditor/components/FormMetadataPanel.jsx
// Debug/Development panel that displays the complete form metadata
// Features:
// - Collapsible panel using HTML details/summary
// - Pretty-printed JSON view
// - Shows current form_id in summary

const FormMetadataPanel = ({ formMetadata }) => (
  <div className="border-t bg-gray-50">
    <details className="relative">
      <summary className="text-xl font-semibold cursor-pointer">
        Form Metadata ({formMetadata.form_id})
      </summary>
      <div className="p-2 bg-gray-100 rounded overflow-auto">
        <pre className="text-xs">
          {JSON.stringify(formMetadata, null, 2)}
        </pre>
      </div>
    </details>
  </div>
);

export default FormMetadataPanel;